'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _common = require('../common');

var _mightyFields = require('../../lib/mighty-fields');

var _ConfirmDelete = require('../common/ConfirmDelete');

var _ConfirmDelete2 = _interopRequireDefault(_ConfirmDelete);

var _SmartBool = require('../../utils/SmartBool');

var _SmartBool2 = _interopRequireDefault(_SmartBool);

var _DeleteReturnButton = require('./DeleteReturnButton');

var _DeleteReturnButton2 = _interopRequireDefault(_DeleteReturnButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var ReturnDetailsWell = (_dec = (0, _mobxReact.inject)('LienStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(ReturnDetailsWell, _Component);

  function ReturnDetailsWell() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReturnDetailsWell);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReturnDetailsWell.__proto__ || Object.getPrototypeOf(ReturnDetailsWell)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'showConfirmation', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReturnDetailsWell, [{
    key: 'handleConfirm',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _props, lien, lien_return, LienStore;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, lien = _props.lien, lien_return = _props.lien_return, LienStore = _props.LienStore;
                _context.next = 3;
                return LienStore.deleteLienReturn(lien_return.id, lien.id, lien.case);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleConfirm() {
        return _ref2.apply(this, arguments);
      }

      return handleConfirm;
    }()
  }, {
    key: 'renderButton',
    value: function renderButton() {
      var lien_return = this.props.lien_return;


      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(_DeleteReturnButton2.default, {
          hasCoopPayment: lien_return.has_coop_payment,
          lienReturnId: lien_return.id,
          onClick: this.showConfirmation.setTrue
        }),
        _react2.default.createElement(_common.PermissionRequiredToolTip, null)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          lien = _props2.lien,
          lien_return = _props2.lien_return,
          className = _props2.className;


      if (!lien || !lien_return) {
        // istanbul ignore next
        return null;
      }

      return _react2.default.createElement(
        'div',
        { style: { 'position': 'relative' } },
        _react2.default.createElement(_ConfirmDelete2.default, {
          message: 'Delete this return?',
          showConfirmDelete: this.showConfirmation.isTrue,
          onClickDelete: this.handleConfirm,
          onClickCancel: this.showConfirmation.setFalse
        }),
        _react2.default.createElement(_mightyFields.Card, {
          className: className,
          fieldSets: [[{
            field: 'type',
            optionKey: 'value',
            optionType: 'returnTypes',
            type: 'optionSelect'
          }, {
            field: 'payer_name'
          }, {
            field: 'matured_date',
            label: 'Date of Payment',
            type: 'date'
          }, {
            field: 'actual_amount',
            label: 'Payment Amount',
            type: 'money'
          }, {
            field: 'notes',
            type: 'text'
          }]],
          model: lien_return,
          renderTopRight: this.renderButton,
          title: 'Payment Details'
        })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return ReturnDetailsWell;
}(_react.Component), _class3.propTypes = {
  className: _propTypes2.default.any,
  lien: _propTypes2.default.object.isRequired,
  lien_return: _propTypes2.default.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'showConfirmation', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _SmartBool2.default();
  }
})), _class2)) || _class) || _class) || _class);
var _default = ReturnDetailsWell;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ReturnDetailsWell, 'ReturnDetailsWell', '/app/src/components/page-case/ReturnDetailsWell.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/ReturnDetailsWell.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL3BhZ2UtY2FzZS9SZXR1cm5EZXRhaWxzV2VsbC5qcyJdLCJuYW1lcyI6WyJSZXR1cm5EZXRhaWxzV2VsbCIsImF1dG9CaW5kTWV0aG9kcyIsIm9ic2VydmVyIiwicHJvcHMiLCJsaWVuIiwibGllbl9yZXR1cm4iLCJMaWVuU3RvcmUiLCJkZWxldGVMaWVuUmV0dXJuIiwiaWQiLCJjYXNlIiwiaGFzX2Nvb3BfcGF5bWVudCIsInNob3dDb25maXJtYXRpb24iLCJzZXRUcnVlIiwiY2xhc3NOYW1lIiwiaXNUcnVlIiwiaGFuZGxlQ29uZmlybSIsInNldEZhbHNlIiwiZmllbGQiLCJvcHRpb25LZXkiLCJvcHRpb25UeXBlIiwidHlwZSIsImxhYmVsIiwicmVuZGVyQnV0dG9uIiwiQ29tcG9uZW50IiwicHJvcFR5cGVzIiwiUHJvcFR5cGVzIiwiYW55Iiwib2JqZWN0IiwiaXNSZXF1aXJlZCIsIm9ic2VydmFibGUiLCJTbWFydEJvb2wiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7QUFBQTs7OztBQUNBOzs7O0FBQ0E7O0FBQ0E7O0FBQ0E7Ozs7QUFFQTs7QUFDQTs7QUFFQTs7OztBQUNBOzs7O0FBRUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQU1NQSxpQixXQUhMLHVCQUFPLFdBQVAsQyxvQkFDQUMsZ0MsZUFDQUMsbUI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozt5QkFTTyxLQUFLQyxLLEVBSFBDLEksVUFBQUEsSSxFQUNBQyxXLFVBQUFBLFcsRUFDQUMsUyxVQUFBQSxTOzt1QkFFSUEsVUFBVUMsZ0JBQVYsQ0FBMkJGLFlBQVlHLEVBQXZDLEVBQTJDSixLQUFLSSxFQUFoRCxFQUFvREosS0FBS0ssSUFBekQsQzs7Ozs7Ozs7Ozs7Ozs7Ozs7O21DQUdRO0FBQUEsVUFDTkosV0FETSxHQUNVLEtBQUtGLEtBRGYsQ0FDTkUsV0FETTs7O0FBR2QsYUFDRTtBQUFDLHVCQUFEO0FBQUE7QUFDRSxzQ0FBQyw0QkFBRDtBQUNFLDBCQUFnQkEsWUFBWUssZ0JBRDlCO0FBRUUsd0JBQWNMLFlBQVlHLEVBRjVCO0FBR0UsbUJBQVMsS0FBS0csZ0JBQUwsQ0FBc0JDO0FBSGpDLFVBREY7QUFNRSxzQ0FBQyxpQ0FBRDtBQU5GLE9BREY7QUFVRDs7OzZCQUVTO0FBQUEsb0JBQ2lDLEtBQUtULEtBRHRDO0FBQUEsVUFDQUMsSUFEQSxXQUNBQSxJQURBO0FBQUEsVUFDTUMsV0FETixXQUNNQSxXQUROO0FBQUEsVUFDbUJRLFNBRG5CLFdBQ21CQSxTQURuQjs7O0FBR1IsVUFBSSxDQUFDVCxJQUFELElBQVMsQ0FBQ0MsV0FBZCxFQUEyQjtBQUN6QjtBQUNBLGVBQU8sSUFBUDtBQUNEOztBQUVELGFBQ0U7QUFBQTtBQUFBLFVBQUssT0FBTyxFQUFFLFlBQVksVUFBZCxFQUFaO0FBQ0Usc0NBQUMsdUJBQUQ7QUFDRSxtQkFBUSxxQkFEVjtBQUVFLDZCQUFtQixLQUFLTSxnQkFBTCxDQUFzQkcsTUFGM0M7QUFHRSx5QkFBZSxLQUFLQyxhQUh0QjtBQUlFLHlCQUFlLEtBQUtKLGdCQUFMLENBQXNCSztBQUp2QyxVQURGO0FBUUUsc0NBQUMsa0JBQUQ7QUFDRSxxQkFBV0gsU0FEYjtBQUVFLHFCQUFXLENBQUMsQ0FDVjtBQUNFSSxtQkFBTyxNQURUO0FBRUVDLHVCQUFXLE9BRmI7QUFHRUMsd0JBQVksYUFIZDtBQUlFQyxrQkFBTTtBQUpSLFdBRFUsRUFPVjtBQUNFSCxtQkFBTztBQURULFdBUFUsRUFVVjtBQUNFQSxtQkFBTyxjQURUO0FBRUVJLG1CQUFPLGlCQUZUO0FBR0VELGtCQUFNO0FBSFIsV0FWVSxFQWVWO0FBQ0VILG1CQUFPLGVBRFQ7QUFFRUksbUJBQU8sZ0JBRlQ7QUFHRUQsa0JBQU07QUFIUixXQWZVLEVBb0JWO0FBQ0VILG1CQUFPLE9BRFQ7QUFFRUcsa0JBQU07QUFGUixXQXBCVSxDQUFELENBRmI7QUEyQkUsaUJBQU9mLFdBM0JUO0FBNEJFLDBCQUFnQixLQUFLaUIsWUE1QnZCO0FBNkJFLGlCQUFNO0FBN0JSO0FBUkYsT0FERjtBQTBDRDs7Ozs7Ozs7Ozs7RUE3RTZCQyxnQixXQStFdkJDLFMsR0FBWTtBQUNqQlgsYUFBV1ksb0JBQVVDLEdBREo7QUFFakJ0QixRQUFNcUIsb0JBQVVFLE1BQVYsQ0FBaUJDLFVBRk47QUFHakJ2QixlQUFhb0Isb0JBQVVFLE1BQVYsQ0FBaUJDO0FBSGIsQyw0RkE5RWxCQyxnQjs7O1dBQThCLElBQUlDLG1CQUFKLEU7OztlQXFGbEI5QixpQjs7Ozs7Ozs7Ozs7MEJBdEZUQSxpQiIsImZpbGUiOiJSZXR1cm5EZXRhaWxzV2VsbC5qcyIsInNvdXJjZVJvb3QiOiIvYXBwIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IENvbXBvbmVudCwgRnJhZ21lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuaW1wb3J0IHsgb2JzZXJ2YWJsZSB9IGZyb20gJ21vYngnO1xuaW1wb3J0IHsgaW5qZWN0LCBvYnNlcnZlciB9IGZyb20gJ21vYngtcmVhY3QnO1xuaW1wb3J0IGF1dG9CaW5kTWV0aG9kcyBmcm9tICdjbGFzcy1hdXRvYmluZC1kZWNvcmF0b3InO1xuXG5pbXBvcnQgeyBQZXJtaXNzaW9uUmVxdWlyZWRUb29sVGlwIH0gZnJvbSAnLi4vY29tbW9uJztcbmltcG9ydCB7IENhcmQgfSBmcm9tICcuLi8uLi9saWIvbWlnaHR5LWZpZWxkcyc7XG5cbmltcG9ydCBDb25maXJtRGVsZXRlIGZyb20gJy4uL2NvbW1vbi9Db25maXJtRGVsZXRlJztcbmltcG9ydCBTbWFydEJvb2wgZnJvbSAnLi4vLi4vdXRpbHMvU21hcnRCb29sJztcblxuaW1wb3J0IEd1YXJkZWREZWxldGVSZXR1cm5CdXR0b24gZnJvbSAnLi9EZWxldGVSZXR1cm5CdXR0b24nO1xuXG5cbkBpbmplY3QoJ0xpZW5TdG9yZScpXG5AYXV0b0JpbmRNZXRob2RzXG5Ab2JzZXJ2ZXJcbmNsYXNzIFJldHVybkRldGFpbHNXZWxsIGV4dGVuZHMgQ29tcG9uZW50IHtcbiAgQG9ic2VydmFibGUgc2hvd0NvbmZpcm1hdGlvbiA9IG5ldyBTbWFydEJvb2woKTtcblxuICBhc3luYyBoYW5kbGVDb25maXJtICgpIHtcbiAgICBjb25zdCB7XG4gICAgICBsaWVuLFxuICAgICAgbGllbl9yZXR1cm4sXG4gICAgICBMaWVuU3RvcmUsXG4gICAgfSA9IHRoaXMucHJvcHM7XG4gICAgYXdhaXQgTGllblN0b3JlLmRlbGV0ZUxpZW5SZXR1cm4obGllbl9yZXR1cm4uaWQsIGxpZW4uaWQsIGxpZW4uY2FzZSk7XG4gIH1cblxuICByZW5kZXJCdXR0b24gKCkge1xuICAgIGNvbnN0IHsgbGllbl9yZXR1cm4gfSA9IHRoaXMucHJvcHM7XG5cbiAgICByZXR1cm4gKFxuICAgICAgPEZyYWdtZW50PlxuICAgICAgICA8R3VhcmRlZERlbGV0ZVJldHVybkJ1dHRvblxuICAgICAgICAgIGhhc0Nvb3BQYXltZW50PXtsaWVuX3JldHVybi5oYXNfY29vcF9wYXltZW50fVxuICAgICAgICAgIGxpZW5SZXR1cm5JZD17bGllbl9yZXR1cm4uaWR9XG4gICAgICAgICAgb25DbGljaz17dGhpcy5zaG93Q29uZmlybWF0aW9uLnNldFRydWV9XG4gICAgICAgIC8+XG4gICAgICAgIDxQZXJtaXNzaW9uUmVxdWlyZWRUb29sVGlwIC8+XG4gICAgICA8L0ZyYWdtZW50PlxuICAgICk7XG4gIH1cblxuICByZW5kZXIgKCkge1xuICAgIGNvbnN0IHsgbGllbiwgbGllbl9yZXR1cm4sIGNsYXNzTmFtZSB9ID0gdGhpcy5wcm9wcztcblxuICAgIGlmICghbGllbiB8fCAhbGllbl9yZXR1cm4pIHtcbiAgICAgIC8vIGlzdGFuYnVsIGlnbm9yZSBuZXh0XG4gICAgICByZXR1cm4gbnVsbDtcbiAgICB9XG5cbiAgICByZXR1cm4gKFxuICAgICAgPGRpdiBzdHlsZT17eyAncG9zaXRpb24nOiAncmVsYXRpdmUnIH19PlxuICAgICAgICA8Q29uZmlybURlbGV0ZVxuICAgICAgICAgIG1lc3NhZ2U9J0RlbGV0ZSB0aGlzIHJldHVybj8nXG4gICAgICAgICAgc2hvd0NvbmZpcm1EZWxldGU9e3RoaXMuc2hvd0NvbmZpcm1hdGlvbi5pc1RydWV9XG4gICAgICAgICAgb25DbGlja0RlbGV0ZT17dGhpcy5oYW5kbGVDb25maXJtfVxuICAgICAgICAgIG9uQ2xpY2tDYW5jZWw9e3RoaXMuc2hvd0NvbmZpcm1hdGlvbi5zZXRGYWxzZX1cbiAgICAgICAgLz5cblxuICAgICAgICA8Q2FyZFxuICAgICAgICAgIGNsYXNzTmFtZT17Y2xhc3NOYW1lfVxuICAgICAgICAgIGZpZWxkU2V0cz17W1tcbiAgICAgICAgICAgIHtcbiAgICAgICAgICAgICAgZmllbGQ6ICd0eXBlJyxcbiAgICAgICAgICAgICAgb3B0aW9uS2V5OiAndmFsdWUnLFxuICAgICAgICAgICAgICBvcHRpb25UeXBlOiAncmV0dXJuVHlwZXMnLFxuICAgICAgICAgICAgICB0eXBlOiAnb3B0aW9uU2VsZWN0JyxcbiAgICAgICAgICAgIH0sXG4gICAgICAgICAgICB7XG4gICAgICAgICAgICAgIGZpZWxkOiAncGF5ZXJfbmFtZScsXG4gICAgICAgICAgICB9LFxuICAgICAgICAgICAge1xuICAgICAgICAgICAgICBmaWVsZDogJ21hdHVyZWRfZGF0ZScsXG4gICAgICAgICAgICAgIGxhYmVsOiAnRGF0ZSBvZiBQYXltZW50JyxcbiAgICAgICAgICAgICAgdHlwZTogJ2RhdGUnLFxuICAgICAgICAgICAgfSxcbiAgICAgICAgICAgIHtcbiAgICAgICAgICAgICAgZmllbGQ6ICdhY3R1YWxfYW1vdW50JyxcbiAgICAgICAgICAgICAgbGFiZWw6ICdQYXltZW50IEFtb3VudCcsXG4gICAgICAgICAgICAgIHR5cGU6ICdtb25leScsXG4gICAgICAgICAgICB9LFxuICAgICAgICAgICAge1xuICAgICAgICAgICAgICBmaWVsZDogJ25vdGVzJyxcbiAgICAgICAgICAgICAgdHlwZTogJ3RleHQnLFxuICAgICAgICAgICAgfSxcbiAgICAgICAgICBdXX1cbiAgICAgICAgICBtb2RlbD17bGllbl9yZXR1cm59XG4gICAgICAgICAgcmVuZGVyVG9wUmlnaHQ9e3RoaXMucmVuZGVyQnV0dG9ufVxuICAgICAgICAgIHRpdGxlPSdQYXltZW50IERldGFpbHMnXG4gICAgICAgIC8+XG4gICAgICA8L2Rpdj5cbiAgICApO1xuICB9XG5cbiAgc3RhdGljIHByb3BUeXBlcyA9IHtcbiAgICBjbGFzc05hbWU6IFByb3BUeXBlcy5hbnksXG4gICAgbGllbjogUHJvcFR5cGVzLm9iamVjdC5pc1JlcXVpcmVkLFxuICAgIGxpZW5fcmV0dXJuOiBQcm9wVHlwZXMub2JqZWN0LmlzUmVxdWlyZWQsXG4gIH07XG59XG5cbmV4cG9ydCBkZWZhdWx0IFJldHVybkRldGFpbHNXZWxsO1xuIl19